/**
* DevExpress HTML/JS Reporting (rich-edit\utils\_inlineControl.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { InlineTextEdit } from '@devexpress/analytics-core/analytics-internal';
export class InlineRichEditControl extends InlineTextEdit {
}
